import defaultLocales from 'globals/locales/default';

export const tabs = [defaultLocales.keys, defaultLocales.redirects];
